export default __webpack_public_path__ + "static/media/elearning.6371c3ff.svg";